<template>
  <section id="wallet-screen" style="margin: 56px 0;">
    <div class="container">
      <b-row>
        <!-- Cards da lateral -->
        <b-col xl="4">
          <div class="d-flex flex-column">
            <TransferBalanceCard />
            <BankAccountCard />
          </div>
        </b-col>

        <b-col xl="8">
          <!-- Card com o Histórico -->
          <div class="sc-card" style="min-height:775px;">
            <div class="sc-card-body">
              <h4 class="sc-card-title mb-3">Histórico de transferências</h4>
              <h6
                class="sc-card-subtitle text-weight-light"
                style="color: #868E96;"
              >
                Aqui você encontrará todas as movimentações bancárias realizadas
                através do aplicativo ou sistema web.
              </h6>

              <div v-if="isLoading" class="d-flex align-items-center justify-content-center mt-4">
                <b-spinner
                  class="align-middle"
                  size="12px"
                  style="height: 32px; width: 32px; font-size: 8px; color: #ed135a;"
                />
              </div>
              <BankTransactionsHistory v-else :transactions="transactions" />
            </div>
          </div>

          <div>
            <b-modal
              id="bankAccount"
              ref="bankAccount"
              size="lg"
              centered
              hide-footer
              hide-header
            >
              <BankAccountForm @bankAccountCreated="bankAccountCreated" />
            </b-modal>
          </div>

          <div>
            <b-modal
              id="bankTransfer"
              ref="bankTransfer"
              size="lg"
              centered
              hide-footer
              hide-header
            >
              <TransferBalanceForm />
            </b-modal>
          </div>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import TransferBalanceCard from "../components/TransferBalanceCard";
import TransferBalanceForm from "../components/TransferBalanceForm";
import BankAccountCard from "../components/BankAccountCard";
import BankAccountForm from "../components/BankAccountForm";
import { formatDate } from "./../utils/masks/formatSlotDate";
import BankTransactionsHistory from '../components/BankTransactionsHistory';

export default {
  name: "DoctorWallet",
  components: {
    TransferBalanceCard,
    TransferBalanceForm,
    BankAccountCard,
    BankAccountForm,
    BankTransactionsHistory
  },
  async mounted() {
    await this.$store.dispatch("doctor/getBankAccount");
    await this.$store.dispatch("doctor/getFinancials");
  },
  methods: {
    format(date) {
      return formatDate(date, "dd 'de' MMMM 'de' YYY");
    },
    accountName(transfer) {
      const bank_name = transfer.bank_account.bank_name;
      const account_number = transfer.bank_account.account_number;
      const account_digit = transfer.bank_account.account_check_number
        ? `-${transfer.bank_account.account_check_number}`
        : "";

      const agency_number = transfer.bank_account.agency_number;
      const agency_digit = transfer.bank_account.agency_check_number
        ? `-${transfer.bank_account.agency_check_number}`
        : "";

      return `${account_number}${account_digit} na agência ${agency_number}${agency_digit} em ${bank_name}`;
    },
    bankAccountCreated() {
      return this.$bvModal.hide("bankAccount");
    }
  },
  computed: {
    transactions() {
      let financials = this.$store.state.doctor.financials;
      return financials.transactions ? financials.transactions : [];
    },
    isLoading() {
      return this.$store.getters['doctor/loading'];
    }
  }
};
</script>

<style>
.modal-content {
  border-radius: 12px !important;
}
</style>
